import React from 'react'

const OrderConfirm=(props)=>{
    return(
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h4>Your order has been placed</h4>
                    <h3>It will be deliverd soon</h3>
       
                </div>
            </div>
        </div>
    )
}

export default OrderConfirm